import * as React from "react";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import {
  DatesMatchContainer,
  DataTableContainer,
  IconWrapper,
  MainDiv,
  CampaignMissingContainer,
} from "pages/Ads/Campaigns/CampaignsStyled";
import CheckRoundIcon from "assets/svgIcons/CheckRoundIcon";
import EditRoundIcon from "assets/svgIcons/EditRoundIcon";
import UpArrowRoundIcon from "assets/svgIcons/UpArrowRoundIcon";
import CloseRoundIcon from "assets/svgIcons/CloseRoundIcon";
import EditIcon from "assets/svgIcons/EditIcon";
import DeleteIcon from "assets/svgIcons/DeleteIcon";
import CopyIcon from "assets/svgIcons/CopyIcon";
import CalendarIcon from "assets/svgIcons/CalendarIcon";
import moment from "moment";
import { useDispatch } from "react-redux";
import { COMMON_SERVICES } from "../../../../redux/reduxToolkitServices/_commonServices/commonServices";
import { IconButton, Modal, Tooltip } from "@mui/material";
import { PopUpContainer } from "assets/css/globle";
import { uuid } from "_helperFunctions/uuid";
import { useNavigate } from "react-router-dom";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { useTranslation } from "react-i18next";
import {
  MAP_GLOBAL_STATES,
  SITEID_GLOBAL_STATE,
  ADS_GLOBAL_STATE,
} from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import { useSelector } from "react-redux";
import { DataGrid } from "@mui/x-data-grid";
import { styled } from "@mui/material/styles";
import _ from "lodash";
import { isUserReadOnly } from "constant";
import { Loader } from "commonComponents/Loader/Loader";
import { CenteredLoader } from "commonComponents/FormElement/Checkbox/CheckboxStyled";

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  border: 0,
  color:
    theme.palette.mode === "light"
      ? "rgba(0,0,0,.85)"
      : "rgba(255,255,255,0.85)",
  fontFamily: ["latoregular"].join(","),
  WebkitFontSmoothing: "auto",
  letterSpacing: "normal",
  "& .MuiDataGrid-columnsContainer": {
    backgroundColor: theme.palette.mode === "light" ? "#fafafa" : "#1d1d1d",
  },
  "& .MuiDataGrid-iconSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-columnHeader": {
    fontSize: "14px",
    fontWeight: "700",
    fontFamily: "latoregular",
    padding: "8px",
    color: " rgb(75, 75, 75)",
    background: "var(--box-header-background)",
  },
  "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
    borderRight: "1px solid rgba(185, 185, 185, 0.5)",
  },
  "& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell": {
    borderBottom: "1px solid rgba(185, 185, 185, 0.5)",
  },
  "& .MuiDataGrid-cell": {
    padding: "8px",
    color:
      theme.palette.mode === "light"
        ? "rgba(0,0,0,.85)"
        : "rgba(255,255,255,0.65)",
  },
  "& .MuiPaginationItem-root": {
    borderRadius: 0,
  },
  "& .highlight": {
    background: "yellow",
  },
  "& .cell-scrollbar": {
    overflowX: "hidden",
    width: "105px",
  },
}));

export default function CampaignsTable({
  convertedData,
  campaignData,
  setSelectedRow,
  selectedRow,
  chooseMessage,
}) {
  const [open, setOpen] = useState(false);
  const [storeId, setStoreId] = useState();
  const [rowSiteId, setRowSiteId] = useState();
  const [rowData, setRowData] = useState(convertedData);
  const [isLoading, setIsLoading] = useState(false);

  let pendingCampId = 0;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const { getUserRole, siteSettingsData } = useSelector((state) => state.commonReducers) || [];
  const {
    shouldShowPublishNow
  } = useHookstate(ADS_GLOBAL_STATE);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "400px",
    width: "100%",
    bgcolor: "background.paper",
    borderRadius: "5px",
    overflow: "hidden",
  };

  useEffect(() => {
    setRowData(convertedData);

    populatePendingPublishCount();
  }, [convertedData]);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
  }, [siteId.get()]);

  ///################SORTING THROUGH ICONS START#################////

  const currentlyPublishedNew = (campaign, currentRowData) => {
    if (currentRowData?.tournamentId) {
      if (campaign?.tournPublishInfo) {
        if (
          currentRowData?.baseVersion === campaign?.tournPublishInfo.version &&
          currentRowData?.lastModifiedUtc <
            campaign?.tournPublishInfo?.publishedUtc
        ) {
          return true;
        }
      }
    } else {
      if (campaign?.publishInfo) {
        if (
          currentRowData.baseVersion === campaign.publishInfo.version &&
          currentRowData.lastModifiedUtc < campaign.publishInfo.publishedUtc
        ) {
          return true;
        }
      }
    }
    return false;
  };

  function currentPublishDate(campaign, currentRowData) {
    if (
      currentlyPublishedNew(campaign, currentRowData) &&
      Object.keys(siteSettingsData).length !== 0
    ) {
      if (currentRowData?.tournamentId && campaign?.tournPublishInfo) {
        let dt = moment
          .utc(campaign?.tournPublishInfo?.publishedUtc)
          .utcOffset(-siteSettingsData?.TimeZoneOffset); // convert to local time zone at course
        return "Published " + dt.format("DD-MMM-YYYY hh:mm a");
      } else if (campaign?.publishInfo) {
        let dt2 = moment
          .utc(campaign?.publishInfo?.publishedUtc)
          .utcOffset(-siteSettingsData?.TimeZoneOffset); // convert to local time zone at course
        return "Published " + dt2.format("DD-MMM-YYYY hh:mm a");
      }
    }
    return "";
  }

  const publishedButModified = (campaign, currentRowData) => {
    if (currentRowData?.tournamentId) {
      if (campaign?.tournPublishInfo) {
        if (
          currentRowData?.baseVersion === campaign?.tournPublishInfo?.version &&
          currentRowData?.lastModifiedUtc >
            campaign?.tournPublishInfo?.publishedUtc
        ) {
          return true;
        }
      }
    } else {
      if (campaign?.publishInfo) {
        if (
          currentRowData?.baseVersion === campaign?.publishInfo?.version &&
          currentRowData?.lastModifiedUtc > campaign?.publishInfo?.publishedUtc
        ) {
          return true;
        }
      }
    }
    return false;
  };

  function compareDates(dateA, dateB) {
    if (!dateA && dateB) return -1;
    if (dateA && !dateB) return 1;
    if (dateA < dateB) return -1;
    if (dateA > dateB) return 1;
    return 0;
  }

  function findPendingCampaign() {
    // Get list of all scheduled non-tournament campaigns that include today in their date range
    let now = moment.utc();
    let list = _.filter(convertedData, function (campaign) {
      if (
        campaign?.startDateUtc &&
        campaign?.endDateUtc &&
        !campaign?.tournamentId
      ) {
        let start = moment.utc(campaign?.startDateUtc);
        if (now.isAfter(start)) {
          let end = moment.utc(campaign?.endDateUtc).add(1, "d");
          if (end.isAfter(now)) {
            return true;
          }
        }
      }
      return false;
    });

    if (list.length > 0) {
      // one or more span today
      // Sort to prioritize based on this logic:
      //    if start dates differ, select campaign with later start date
      //    else select campaign with earlier end date
      list.sort(function (a, b) {
        if (compareDates(a?.startDateUtc, b?.startDateUtc) !== 0)
          return compareDates(b?.startDateUtc, a?.startDateUtc);
        return compareDates(a?.endDateUtc, b?.endDateUtc);
      });
      pendingCampId = list[0]?.Id;
    } else {
      // No scheduled campaigns include today, select base campaign
      let def = _.find(convertedData, function (campaign) {
        return campaign?.startDateUtc === null; // base campaign has NULL start/end dates
      });
      if (def) pendingCampId = def?.Id;
      else pendingCampId = 0; // jic
    }
  }

  findPendingCampaign();

  const pendingPublish = (campaign, currentRowData) => {
    if (currentRowData?.tournamentId) {
      if (campaign?.tournPublishInfo) {
        let now = new moment.utc();
        let start = moment.utc(currentRowData?.startDateUtc);
        if (now.isAfter(start)) {
          let end = moment.utc(currentRowData?.endDateUtc).add(1, "d");
          if (end.isAfter(now)) {
            if (
              campaign?.tournPublishInfo?.publishedUtc <
                currentRowData?.lastModifiedUtc ||
              currentRowData?.baseVersion !==
                campaign?.tournPublishInfo?.version
            )
              return (
                currentRowData?.welcomeAd &&
                currentRowData?.welcomeAd.imageId !== 0 &&
                currentRowData?.fbAd &&
                currentRowData?.fbAd.imageId !== 0
              );
          }
        }
      }
    } else {
      if (
        currentRowData?.Id === pendingCampId &&
        !currentlyPublishedNew(campaign, currentRowData)
      )
        return (
          currentRowData?.welcomeAd &&
          currentRowData?.welcomeAd.imageId !== 0 &&
          currentRowData?.fbAd &&
          currentRowData?.fbAd.imageId !== 0
        );
    }
    return false;
  };

  const pendingPublishButCant = (campaign, currentRowData) => {
    if (currentRowData?.tournamentId) {
      if (campaign?.tournPublishInfo) {
        let now = new moment.utc();
        let start = moment.utc(currentRowData?.startDateUtc);
        if (now.isAfter(start)) {
          let end = moment.utc(currentRowData?.endDateUtc).add(1, "d");
          if (end.isAfter(now)) {
            if (
              campaign?.tournPublishInfo?.publishedUtc <
                currentRowData?.lastModifiedUtc ||
              currentRowData?.baseVersion !==
                campaign?.tournPublishInfo?.version
            )
              return (
                (currentRowData?.welcomeAd &&
                  currentRowData?.welcomeAd?.imageId === 0) ||
                (currentRowData?.fbAd && currentRowData?.fbAd?.imageId === 0)
              );
          }
        }
      }
    } else {
      if (
        currentRowData.Id === pendingCampId &&
        !currentlyPublishedNew(campaign, currentRowData)
      )
        return (
          (campaign?.welcomeAd && campaign?.welcomeAd?.imageId === 0) ||
          (campaign?.fbAd && campaign?.fbAd?.imageId === 0)
        );
    }
    return false;
  };

  function populatePendingPublishCount() {
    let count = convertedData?.length !== 0 ? convertedData.filter((c) => {
            return pendingPublish(campaignData, c);
          }).length : 0;

    chooseMessage(count);

    return count;
  }

  const tournamentTitle = (currentRowData) => {
    if (currentRowData.tournamentId) {
      return currentRowData.tournamentName;
    }
    return "";
  };

  ///################SORTING THROUGH ICONS END #################////

  //*******************Handle for Delete****************************//
  
  const handleClose = () => {
    setOpen(false);
  };

  const handleDeleteButton = (Id, rowSiteID) => {
    setIsLoading(true);
    setOpen(false);

    dispatch(COMMON_SERVICES.deleteCampaignServices(Id, rowSiteID)).then(() => {
      dispatch(COMMON_SERVICES.getCampaignsServices(siteId.get()));
      setIsLoading(false);
    });
  };

  const handleDeleteButtonFunction = (Id, selectedRowSiteID) => {
    setOpen(true);
    setStoreId(Id);
    setRowSiteId(selectedRowSiteID);
  };

  //################## HANDLE FOR COPY START #######################//

  const handleCopyRow = (row, index) => {
    let copyArr = [...rowData];

    copyArr.splice(index + 1, 0, {
      ...copyArr[index],
      Description: `[Copy of]${copyArr[index].Description}`,
      Id: `${uuid()}`,
    });

    const payload = {
      siteId: row.SiteId,
      campaignId: row.Id,
    };

    dispatch(COMMON_SERVICES.copyCampaignsServices(payload)).then(() => {
      dispatch(COMMON_SERVICES.getCampaignsServices(siteId.get()));
      setRowData(copyArr);
    });
  };

  function navigateToEditCampaign(evt) {
    const getId = evt.target.id;

    const filteredData = convertedData?.filter((item) => item.Id == getId);

    navigate("/ads", { state: { filteredData } });
  }

  function durationDays(campaign) {
    if (campaign.startDateUtc && campaign.endDateUtc) {
      var start = moment.utc(campaign.startDateUtc);
      var end = moment.utc(campaign.endDateUtc);
      return end.diff(start, "days") + 1;
    }
    return "-"; // avoid zero since that's used to trigger alert
  }

  let dateMatch = [];
  let temp = [];
  rowData.map((data) => {
    temp = [];
    temp = rowData.filter((item) => {
      let itemStartDateUtc = new Date(item.startDateUtc);
      let dataStartDateUtc = new Date(data.startDateUtc);
      let itemEndDateUtc = new Date(item.endDateUtc);
      let dataEndDateUtc = new Date(data.endDateUtc);
      return (
        dataStartDateUtc.toDateString() === itemStartDateUtc.toDateString() &&
        dataEndDateUtc.toDateString() === itemEndDateUtc.toDateString() &&
        data.Id !== item.Id
      );
    });
    dateMatch = [...dateMatch, ...temp];
  });

  let dateMatchStartDates = dateMatch.map((data) => data.Id);
  let dateMatchEndDates = dateMatch.map((data) => data.Id);

  let custom = rowData.filter(
    (item) => item.Description !== "Default campaign"
  );
  custom = [
    ...rowData.filter((item) => item.Description === "Default campaign"),
    ...custom,
  ];

  let rows = custom.map((row) => {
    return {
      ...row,
      id: row.Id,
      Description: row.Description,
      startDateUtc: row.startDateUtc,
      endDateUtc: row.endDateUtc,
      campDays: durationDays(row),
    };
  });

  const handleStartAndEndDate = (date) => {
    if (date) {
       var dateMoment = moment.utc(date).utcOffset(-siteSettingsData?.TimeZoneOffset);  // convert to local time zone at course
       return dateMoment.format('DD-MMM-YYYY');
    }
    return '-';
 }

  const headCells = [
    {
      field: t("Description"),
      headerName: t("Description"),
      headerAlign: "center",
      width: 200,
      headerClassName: "lastcolumnSeparator",
      align: "center",
      renderCell: (params) => {
        function findDefaultCampaignMissingImages() {
          if (params.row.Description === "Default campaign") {
            return (
              (params.row.welcomeAd && params.row.welcomeAd.imageId === 0) ||
              (params.row.fbAd && params.row.fbAd.imageId === 0)
            );
          }
        }

        return (
          <MainDiv
            className="cell-scrollbar"
            style={{
              color: findDefaultCampaignMissingImages() ? "red" : "",
            }}
          >
            <Tooltip title={params?.row.Description}>
              <p>{params?.row.Description}</p>
            </Tooltip>

            <IconWrapper>
              <div>
                {currentlyPublishedNew(campaignData, params?.row) ? (
                  <>
                    <Tooltip
                      className="tooltip"
                      title={currentPublishDate(campaignData, params?.row)}
                    >
                      <button>
                        <CheckRoundIcon />
                      </button>
                    </Tooltip>
                  </>
                ) : (
                  <></>
                )}

                {publishedButModified(campaignData, params?.row) ? (
                  <>
                    <EditRoundIcon />
                  </>
                ) : (
                  <></>
                )}

                {pendingPublish(campaignData, params?.row) ? (
                  <UpArrowRoundIcon />
                ) : (
                  <></>
                )}
                {pendingPublishButCant(campaignData, params?.row) ? (
                  <CloseRoundIcon />
                ) : (
                  <></>
                )}

                {tournamentTitle(params?.row) ? (
                  <>
                    <Tooltip
                      className="tooltip"
                      title={
                        params?.row?.tournamentName +
                        " [" +
                        params?.row?.tournamentId +
                        "]"
                      }
                    >
                      <EmojiEventsIcon style={{ color: "#947550" }} />
                    </Tooltip>
                  </>
                ) : (
                  ""
                )}
              </div>

              <div>
                <Tooltip title={t("Copy")}>
                  <IconButton
                    disabled={
                      isUserReadOnly(getUserRole && getUserRole?.Role)
                    }
                    className="toolTip"
                    onClick={() =>
                      handleCopyRow(
                        params?.row,
                        params.api.getRowIndex(params.row.id)
                      )
                    }
                  >
                    <CopyIcon />{" "}
                  </IconButton>
                </Tooltip>
                <Tooltip title={t("Edit")}>
                  <IconButton
                    disabled={
                      isUserReadOnly(getUserRole && getUserRole?.Role)
                    }
                    className="toolTip"
                    id={params?.row?.Id}
                    onClick={(e) => {
                      mapSideNavTabState.set("editCampaign");
                      navigateToEditCampaign(e);
                    }}
                  >
                    <EditIcon
                      color="#EAB52D"
                      width={15}
                      height={15}
                      pointerEvents="none"
                    />
                  </IconButton>
                </Tooltip>
                {params?.row.Description !== "Default campaign" &&
                params?.row.Description !== "Default Campaign" &&
                params?.row.endDateUtc !== null &&
                params?.row.startDateUtc !== null ? (
                  <Tooltip title={t("Delete")}>
                    <IconButton
                      disabled={
                        isUserReadOnly(getUserRole && getUserRole?.Role)
                      }
                      className="toolTip"
                      onClick={() =>
                        handleDeleteButtonFunction(
                          params?.row.Id,
                          params?.row.SiteId
                        )
                      }
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                ) : (
                  ""
                )}
              </div>
            </IconWrapper>
          </MainDiv>
        );
      },
    },
    {
      field: "startDateUtc",
      headerName: t("Start_Date"),
      headerAlign: "center",
      width: 150,
      headerClassName: "lastcolumnSeparator",
      align: "center",
      renderCell: (params) => {
        return (
          <MainDiv className="single-icon">
            {handleStartAndEndDate(params?.row.startDateUtc)}
            <IconWrapper>
              <div style={{ textAlign: "right" }}>
                <CalendarIcon />
              </div>
            </IconWrapper>
          </MainDiv>
        );
      },
      sortComparator: (v1, v2) => {
        if (v1 === v2) return 0;
        if (v1 === null) return 1;
        if (v2 === null) return -1;

        if (v1 < v2) return -1;
        if (v1 > v2) return 1;
        return 0;
      },
      cellClassName: (params) => {
        return dateMatchStartDates.includes(params.row.Id) ? "highlight" : "";
      },
    },
    {
      field: "endDateUtc",
      headerName: t("End_Date"),
      headerAlign: "center",
      width: 150,
      headerClassName: "lastcolumnSeparator",
      align: "center",
      renderCell: (params) => {
        return (
          <MainDiv className="single-icon">
            {handleStartAndEndDate(params?.row.endDateUtc)}
            <IconWrapper>
              <div>
                <CalendarIcon />
              </div>
            </IconWrapper>
          </MainDiv>
        );
      },
      cellClassName: (params) => {
        return dateMatchEndDates.includes(params.row.Id) ? "highlight" : "";
      },
    },
    {
      field: "campDays",
      headerName: t("Campaign_Days"),
      headerAlign: "center",
      type: "number",
      width: 130,
      headerClassName: "lastcolumnSeparator",
      align: "center",
      renderCell: (params) => {
        return <div>{durationDays(params?.row)}</div>;
      },
    },
  ];

  const defaultCampaignMissingImages = () => {
    if (rows && rows.length) {
      let defaultCampaign = _.find(rows, function (c) {
        return (
          c.Description &&
          c.Description.toLowerCase().includes("default campaign".toLowerCase())
        );
      });
      return defaultCampaign
        ? (defaultCampaign.welcomeAd &&
            defaultCampaign.welcomeAd.imageId === 0) ||
            (defaultCampaign.fbAd && defaultCampaign.fbAd.imageId === 0)
        : false;
    }
    return false;
  };

  return (
    <Box sx={{ width: "100%" }}>

    {!isLoading ? 
      <DataTableContainer className="no-pagination">
        <StyledDataGrid
          rows={rows}
          columns={headCells}
          checkboxSelection
          disableSelectionOnClick
          disableColumnMenu
          getRowId={(row) => row.id}
          isRowSelectable={(params) =>
            params.row.Description !== "Default campaign"
          }
          selectionModel={selectedRow}
          onSelectionModelChange={(itm) => setSelectedRow(itm)}
          getRowHeight={() => "auto"}
          initialState={{
            sorting: {
              sortModel: [{ field: "startDateUtc", sort: "desc" }],
            },
          }}
        />
      </DataTableContainer>
      : (<CenteredLoader>
          <Loader />
        </CenteredLoader>
        )}

      {dateMatch.length > 0 && (
        <DatesMatchContainer>
          <div>Dates match</div>
        </DatesMatchContainer>
      )}
      {defaultCampaignMissingImages() ? (
        <CampaignMissingContainer>
          <p style={{ color: "red", font: "inherit", margin: 0 }}>
            Default campaign missing Welcome and/or F&amp;B images
          </p>
        </CampaignMissingContainer>
      ) : (
        ""
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>{t("Are_you_sure_you_want_to_delete_this_Campaign")}</p>
            <div className="action-btn">
              <button
                onClick={() => handleDeleteButton(storeId, rowSiteId)}
                className="primary"
              >
                {t("Yes")}
              </button>
              <button onClick={() => setOpen(false)}>{t("No")}</button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    </Box>
  );
}
